import SDIcon from '../../SDIcon'

const IconFlagAT = (props) => (
  <SDIcon title='Austria' defaultColorKey='contentPrimary' viewBox='0 0 24 24' {...props}>
    <rect x="3" y="6" width="18" height="12" rx="2" fill="#FFFFFF" />
    <path d="M5 6h14a2 2 0 0 1 2 2v2H3V8a2 2 0 0 1 2-2z" fill="#E22D2D" />
    <path d="M3 14h18v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2z" fill="#E22D2D" />
    <rect
    x="3"
    y="6"
    width="18"
    height="12"
    rx="2"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    opacity="0.35"
    />
  </SDIcon>
)

export default IconFlagAT
